import "./scripts/carousel";

import "./styles/home.scss";
import "./styles/featurettes.scss";
